import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const formEntityAdapter: EntityAdapter = {
  entity: "form",
  defaultSort: { sort: "name", tableSort: "name", descending: false },
};
